var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect, useState } from "react";
import { updateSessionListStore, useSessionListStore } from "../store/sessionlist.store";
import { deleteSession, getSessionDetails, joinSession } from "../services/session.service";
import { MessageService } from "../services/message.service";
import { useTranslation } from "react-i18next";
export function useSessionSelectHandlers(onJoinClick, onSessionCreated) {
    const [targetSession, setTargetSession] = useState();
    const [targetSessionName, setTargetSessionName] = useState(); // TODO: It's really ugly to have two different ways of storing the target session
    const [currentSessionName, setCurrentSessionName] = useState();
    const [targetEqualsCurrent, setTargetEqualsCurrent] = useState(true);
    const { t } = useTranslation();
    const sessionList = useSessionListStore((state) => state.sessions);
    const setSessionList = useSessionListStore((state) => state.setSessions);
    useEffect(() => {
        const storedSessionName = localStorage.getItem("session");
        if (storedSessionName) {
            if (!targetSessionName && sessionList.length > 0) {
                const lastSession = sessionList.find((session) => session.name === storedSessionName);
                if (lastSession) {
                    setTargetSession(lastSession);
                    setTargetSessionName(storedSessionName);
                    setCurrentSessionName(storedSessionName);
                }
                else {
                    setTargetSession(sessionList[0]);
                    setTargetSessionName(sessionList[0].name);
                    setCurrentSessionName(sessionList[0].name);
                }
            }
        }
    }, [sessionList]);
    useEffect(() => {
        if (currentSessionName && targetSessionName) {
            setTargetEqualsCurrent(currentSessionName === targetSessionName);
        }
    }, [currentSessionName, targetSessionName]);
    const switchSession = () => {
        if (targetSession) {
            getSessionDetails(targetSession.name)
                .then((sessionDetails) => {
                console.log(sessionDetails);
                void joinSession(targetSession.name, sessionDetails.layout, sessionDetails.isWorld);
            })
                .catch((error) => {
                console.error(error);
                MessageService.showMessage("error", t("common:session-select-error-get-details", "Error getting session details for {{sessionName}}", { sessionName: targetSession.name }));
            });
            onJoinClick();
        }
        else {
            console.error("No session selected");
            MessageService.showMessage("error", t("common:session-select-error-no-selection", "No session selected"));
        }
    };
    const handleSessionSelectionChanged = (session) => __awaiter(this, void 0, void 0, function* () {
        setTargetSession(session);
        setTargetSessionName(session === null || session === void 0 ? void 0 : session.name);
    });
    const handleSessionCreated = (newSessionName) => __awaiter(this, void 0, void 0, function* () {
        yield updateSessionListStore();
        setTargetSessionName(newSessionName);
        onSessionCreated();
        MessageService.showMessage("success", t("common:session-select-toast-create-success", "Session {{sessionName}} successfully created", { sessionName: newSessionName }));
    });
    const handleDeleteSession = (session) => __awaiter(this, void 0, void 0, function* () {
        try {
            yield deleteSession(session.name);
            MessageService.showMessage("success", t("common:session-select-toast-delete-success", "Session {{sessionName}} successfully deleted", { sessionName: session.name }));
            setSessionList(sessionList.filter((s) => s.name !== session.name));
            setTargetSession(undefined);
            setTargetSessionName(undefined);
        }
        catch (error) {
            console.error("MainView: deleteSession: Error deleting session", error);
            MessageService.showMessage("success", t("common:session-select-error-delete-session", "Error deleting session {{sessionName}}", { sessionName: session.name }));
        }
    });
    return {
        targetSession,
        targetSessionName,
        setTargetSessionName,
        targetEqualsCurrent,
        switchSession,
        handleSessionSelectionChanged,
        handleSessionCreated,
        handleDeleteSession
    };
}
